"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Embed = exports.Root = void 0;
const Root = _ref => {
  let {
    width,
    height
  } = _ref;
  return Object.assign(Object.assign(Object.assign({}, height && {
    height: +height ? `${height}px` : height
  }), width && {
    width: +width ? `${width}px` : width
  }), {
    display: 'inline-block',
    overflow: 'hidden',
    backgroundColor: 'rgb(54, 57, 62)',
    borderRadius: 7,
    verticalAlign: 'top'
  });
};
exports.Root = Root;
exports.Embed = {
  width: '100%',
  height: '100%',
  border: 'none'
};